import { render } from "./Genealogy.vue?vue&type=template&id=5e3f7662&scoped=true"
import script from "./Genealogy.vue?vue&type=script&lang=js"
export * from "./Genealogy.vue?vue&type=script&lang=js"

import "./Genealogy.vue?vue&type=style&index=0&id=5e3f7662&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e3f7662"]])

export default __exports__